RivalIQ.apps.Insights.module('widgets.media', function (media, App, Backbone, Marionette, $, _) {

    'use strict';


    const ManageColumnsBtn = RivalIQ.views.Link.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        linkName: 'Manage Columns...',
        className: 'btn btn-default btn-xs manage-columns',
        action: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.TableMetricChooser({
                dashboardModel: me.dashboardModel
            }));
        }
    });

    const DetailsLayoutDropdown = RivalIQ.apps.SocialPosts.views.PostLayoutDropdown.extend({
        template: '#discoveryPostGridSwitchTemplate',

        onSelectDropdown: function (data) {
            const me = this;
            // don't need to set layout to undefined; widget defaults to list view in any unrecognized case
            const layout = data.itemId;
            _.defer(function () {
                me.setProps('layout', layout);
                RivalIQ.apps.SocialPosts.utils.updateUserChannelLayout(me.getProp('channel'), layout);
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangePostWidgetLayout, {
                channel: me.getProp('channel'),
                layout: layout,
                curationId: me.dashboardModel.getCuration().id
            });
        }
    });

    const SortDropdown = RivalIQ.apps.SocialPosts.views.SortDropdown.extend({
        template: '#socialPostsSortDropdownSmallTemplate',
        defaultSelector: function () {
            const me = this;

            let index = 0;

            const orderBy = me.getProp('orderBy');
            if (orderBy) {
                const metrics = me.getMetrics();
                const metricIdx = _.findIndex(metrics, function (metric) {
                    return metric.get('property') === orderBy;
                });

                if (metricIdx !== -1) {
                    index = metricIdx;
                }

                if (RivalIQ.apps.SocialPosts.utils.isTopBottomLayout(me) && metricIdx === -1) {
                    index = _.findIndex(metrics, function (metric) {
                        return metric.get('property') === 'engagement_total';
                    });
                    me.setProps({
                        orderBy: 'engagement_total'
                    });
                }
            }

            return `[data-item-id=${index}]`;
        },
        getSortProperties: function (objectType) {
            const me = this;
            const sortableProperties = App.widgets.media.utils.getSortProperties(me.dashboardModel, objectType);
            if (RivalIQ.apps.SocialPosts.utils.isTopBottomLayout(me)) {
                // remove sorting attributes that don't make sense to sort for top/bottom
                _.remove(sortableProperties, _.matches('published_at'));
                _.remove(sortableProperties, _.matches('media_type'));
                _.remove(sortableProperties, _.matches('admin_creator_name'));
                _.remove(sortableProperties, _.matches('tweetType'));
                _.remove(sortableProperties, _.matches('presence_reach'));
            }
            return sortableProperties;
        },
        getMetrics: function () {
            const me = this;
            const objectType = me.getProp('objectType');
            const sortableProperties = me.getSortProperties(objectType);
            return _.map(sortableProperties, function (property) {
                return new RivalIQ.models.MetricDefinition(App.utils.createInsightsMetric(objectType, _.defaults({
                    property: property,
                    channel: me.getProp('channel')
                })));
            });
        },
        getGroups: function (selectableItems) {
            const me = this;

            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                const metricGroups = RivalIQ.apps.Favorites.data.metrics.getMetricGroups();

                const sortGroups = _.reduce(selectableItems, function (memo, item) {
                    const sortingGroup = RivalIQ.models.metrics.getProperty(item._metric, 'collection');
                    const group = _.find(metricGroups, {
                        value: sortingGroup
                    });

                    let groupConfig = memo[sortingGroup];
                    if (!groupConfig) {
                        groupConfig = memo[sortingGroup] = {
                            id: sortingGroup,
                            name: group.label,
                            selectableItems: []
                        };
                    }

                    groupConfig.selectableItems.push(item);
                    return memo;
                }, {});

                return _.values(sortGroups);
            }

            return RivalIQ.apps.SocialPosts.views.SortDropdown.prototype.getGroups.apply(me, arguments);
        },
        onSelectDropdown: function (data) {
            const me = this;

            const objectType = me.getProp('objectType');
            const sortableProperties = me.getSortProperties(objectType);

            const orderBy = sortableProperties[data.itemId];

            me.setProps({
                orderBy: orderBy
            });
        }
    });

    media.MediaViewPanel = App.views.ManageColumnsPanel = RivalIQ.apps.SocialPosts.widgets.PostPanel.extend({
        panelTitleView: RivalIQ.apps.Dashboard.views.PanelTitle,

        getEditActionRenderState: function () {
            const me = this;
            const widget = me.dashboardModel;

            let popover = null;
            let className = RivalIQ.apps.SocialPosts.widgets.PostPanel.prototype.getEditActionClassName.apply(me, arguments);
            if (widget.curation.isCustomDashboard) {
                const source = RivalIQ.enums.sources.INSTAGRAM_INSIGHTS;
                if (RivalIQ.props.channelRedacted(widget.getProps(), source)) {
                    className += ' disabled';
                    popover = {
                        content: 'This widget cannot be edited because you do not have access to Instagram Insights.',
                        html: true,
                        placement: 'auto',
                        trigger: 'hover'
                    };
                } else {
                    const state = widget.getWidgetInstanceState();
                    const companies = _.get(state, ['metadata', 'companies']);
                    if (_.isEmpty(companies)) {
                        className += ' disabled';
                        popover = {
                            content: 'This widget cannot be edited because companies in this landscape do not have access to Instagram Insights.',
                            html: true,
                            placement: 'auto',
                            trigger: 'hover'
                        };
                    }
                }
            }

            return {
                className: className,
                popover: popover
            };
        },

        showActions: function () {
            const me = this;
            const dashboardModel = me.dashboardModel;

            if (dashboardModel.curation.isCustomDashboard) {
                me.showEditActions();
            } else {

                if (me.dashboardModel.isFocus() && me.dashboardModel.region === 'hashtags') {

                    let objectWord;
                    if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.story) {
                        objectWord = 'Frames';
                    } else {
                        objectWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;
                    }

                    const MinimumPostsDropdown = RivalIQ.apps.SocialPosts.utils.createNumericFilterDropdown({
                        label: `Min. ${objectWord}`,
                        prop: 'hashtagsMinPosts',
                        propDefaultValue: 1,
                        min: 1,
                        max: 10
                    });

                    me.actions.show(new MinimumPostsDropdown({
                        dashboardModel: me.dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

                if (me.dashboardModel.isFocus() && me.dashboardModel.region === 'post-tags') {
                    me.actions.show(new RivalIQ.views.ShowSummaryRowSwitch({
                        dashboardModel: me.dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

                // post tag hide / show toggle
                if (me.dashboardModel.region === 'posts' && !RivalIQ.apps.SocialPosts.utils.isTopBottomLayout(me)) {
                    me.actions.show(new RivalIQ.views.ShowPostTagsSwitch({
                        dashboardModel: me.dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

                if (_.includes(['posts', 'stories'], me.dashboardModel.region)) {
                    me.actions.show(new DetailsLayoutDropdown({
                        dashboardModel: dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

                const layout = me.getProp('layout');
                if (dashboardModel.isFocus()) {
                    if (layout && layout !== 'list') {
                        me.actions.show(new SortDropdown({
                            dashboardModel: dashboardModel
                        }), {
                            preventDestroy: true
                        });
                    }
                }

                if (!layout || layout === 'list') {
                    me.actions.show(new ManageColumnsBtn({
                        dashboardModel: dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

            }

            if (!dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        }
    });

});
